import { ReactComponent as Facebook } from './facebook.svg';
import { ReactComponent as Instagram } from './instagram.svg';
import { ReactComponent as Twitter } from './twitter.svg';
import { ReactComponent as TikTok } from './TikTok.svg';
import { ReactComponent as Youtube } from './youtube.svg';
import { ReactComponent as Linkedin } from './linkedin.svg';
import { ReactComponent as Whatsapp } from './whatsapp.svg';
import { getRegisterLink } from '../../shared/tools';
import clubLabellise from '../../assets/labels/club-labelise.png';
import style from './style.module.scss';

const EncartContact = ({ post, hasLabels = false }) => {
    const address =
        post.acf.zipcode_club && post.acf.city_club ? (
            <>
                {post.acf.address_club}
                <br />
                {post.acf.zipcode_club} {post.acf.city_club}
            </>
        ) : null;

    const email = getRegisterLink(post);
    const phone = post.acf.tel_club || post.acf.telephone_portable;
    const phoneFormat = phone ? phone.match(/.{1,2}/g).join(' ') : null;
    let url = null;

    // Socials
    let facebook = null;
    let twitter = null;
    let instagram = null;
    let linkedin = null;
    let youtube = null;
    let tiktok = null;
    let whatsapp = null;

    const addPrefixHTTPS = (link) => {
        if (typeof link === 'string' && link.startsWith('www')) {
            return 'https://' + link;
        }
        return link;
    };

    if (post.post_type === 'smartfire-clubs') {
        facebook = addPrefixHTTPS(post.acf.facebook_club) || null;
        twitter = addPrefixHTTPS(post.acf.twitter_club) || null;
        instagram = addPrefixHTTPS(post.acf.instagram_club) || null;
        linkedin = addPrefixHTTPS(post.acf.linkedin_club) || null;
        youtube = addPrefixHTTPS(post.acf.youtube_club) || null;
        tiktok = addPrefixHTTPS(post.acf.tiktok_club) || null;
        whatsapp = addPrefixHTTPS(post.acf.whatsapp_club) || null;
        url = addPrefixHTTPS(post.acf.url_club) || null;
    } else {
        facebook = addPrefixHTTPS(post.acf.facebook_url) || null;
        twitter = addPrefixHTTPS(post.acf.twitter_url) || null;
        instagram = addPrefixHTTPS(post.acf.instagram_url) || null;
        youtube = addPrefixHTTPS(post.acf.youtube_url) || null;
        linkedin = addPrefixHTTPS(post.acf.linkedin_url) || null;
        tiktok = addPrefixHTTPS(post.acf.tiktok_url) || null;
        url = addPrefixHTTPS(post.acf.website) || null;
    }

    const hasAddress = address || url;

    const hasContact = email || phone;

    const hasSocials =
        facebook || instagram || twitter || tiktok || youtube || linkedin || whatsapp;

    const hasContactContainer = hasContact || hasSocials;

    return (
        <div className={style.encart}>
            {hasLabels && (
                <>
                    <img
                        src={clubLabellise}
                        alt="Club labellisé"
                        className={style.clubLabellise}
                    />
                    <div className={style.border} />
                </>
            )}
            {hasAddress && (
                <div className={style.addressContainer}>
                    {address && (
                        <div className={style.address}>
                            <span className={style.icon}>📍</span>
                            <span>{address}</span>
                        </div>
                    )}
                    {url && (
                        <div className={style.website}>
                            <span className={style.icon}>🖥️️️</span>
                            <a href={url} target="_blank" rel="noreferrer">
                                {url}
                            </a>
                        </div>
                    )}
                </div>
            )}
            {hasContactContainer && (
                <div className={style.contactContainer}>
                    {hasContact && (
                        <div className={style.contacts}>
                            {email && (
                                <div className={style.email}>
                                    <span className={style.icon}>✉️</span>
                                    {post.post_type === 'smartfire-clubs' ? (
                                        <a href={email} target="_blank" rel="noreferrer">
                                            Nous contacter
                                        </a>
                                    ) : (
                                        <a
                                            href={'mailto:' + post.acf.email}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {post.acf.email}
                                        </a>
                                    )}
                                </div>
                            )}

                            {phone && (
                                <div className={style.phone}>
                                    <span className={style.icon}>📞</span>
                                    <a href={'tel:' + phone}>{phoneFormat}</a>
                                </div>
                            )}
                        </div>
                    )}
                    {hasSocials && (
                        <div className={style.socials}>
                            {facebook && (
                                <a href={facebook} target="_blank" rel="noreferrer">
                                    <Facebook />
                                </a>
                            )}
                            {instagram && (
                                <a href={instagram} target="_blank" rel="noreferrer">
                                    <Instagram />
                                </a>
                            )}
                            {twitter && (
                                <a
                                    href={twitter}
                                    target="_blank"
                                    rel="noreferrer"
                                    className={style.twitter}
                                >
                                    <Twitter />
                                </a>
                            )}
                            {tiktok && (
                                <a href={tiktok} target="_blank" rel="noreferrer">
                                    <TikTok />
                                </a>
                            )}
                            {youtube && (
                                <a href={youtube} target="_blank" rel="noreferrer">
                                    <Youtube />
                                </a>
                            )}
                            {linkedin && (
                                <a href={linkedin} target="_blank" rel="noreferrer">
                                    <Linkedin />
                                </a>
                            )}
                            {whatsapp && (
                                <a href={whatsapp} target="_blank" rel="noreferrer">
                                    <Whatsapp />
                                </a>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default EncartContact;
